var map = {
	"./DPE_A.png": "2aeb2",
	"./DPE_B.png": "b703",
	"./DPE_C.png": "872f",
	"./DPE_D.png": "b2bc",
	"./DPE_E.png": "d48e",
	"./DPE_F.png": "9eed",
	"./DPE_G.png": "64bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6011";